import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import tranEn from "./en/resource.json";
import tranKo from "./ko/resource.json";
import tranAr from "./ar/resource.json";

const resources = {
  en: { translation: tranEn },
  ko: { translation: tranKo },
  ar: { translation: tranAr },
};

const fallbackLng = ["en"];

interface Navigator1 {
  userLanguage?: string;
  browserLanguage?: string;
  languages: readonly string[];
  language: string;
}

const nowNavigator: Navigator1 = window.navigator;

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    interpolation: {
      escapeValue: false, // 이걸 해줘야 '/'가 &#x2F;로 안 변해요
    },
    lng:
      window.navigator.language === "ar"
        ? "ar"
        : ["ko", "ko-KR", "ko-kr"].includes(window.navigator.language)
        ? "ko"
        : ["en", "en-US", "en-us"].includes(window.navigator.language)
        ? "en"
        : nowNavigator.browserLanguage &&
          ["ko", "ko-KR", "ko-kr"].includes(nowNavigator.browserLanguage)
        ? "ko"
        : "en",
    fallbackLng,
    debug: true,
  });

export default i18next;
